export const transitionPrefix = 'transition-';
export const defaultEnterTimeout = 300;
export const defaultLeaveTimeout = 300;


// WEBPACK FOOTER //
// ./lib/helpers/transition/defaults.js